import React from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";

const Popup = ({ content, isOpen, closeFunction, popupStyles, propsObj }) => {
  return (
    <Modal
      open={isOpen}
      onClose={() => closeFunction(false)}
      closeOnEsc={propsObj?.closeOnEsc}
      closeOnOverlayClick={propsObj?.closeOnOverlayClick}
      showCloseIcon={propsObj?.showCloseIcon}
      center={propsObj?.center}
      classNames={{
        overlay: propsObj?.overlayClasses,
        modal: propsObj?.modalClasses,
      }}
    >
      <div>{content}</div>
    </Modal>
  );
};

export default Popup;
